// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"b5cbfcb9","37":"bcc01204","110":"4c58cbf5","918":"f5615967"}[chunkId] + ".chunk.js";
};